Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();
var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


ErrorBar=function(_React$Component){_inherits(ErrorBar,_React$Component);
function ErrorBar(props){_classCallCheck(this,ErrorBar);return _possibleConstructorReturn(this,(ErrorBar.__proto__||Object.getPrototypeOf(ErrorBar)).call(this,
props));
}_createClass(ErrorBar,[{key:"componentWillMount",value:function componentWillMount()
































{
this.style=this.getStyle(this.props);
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _props=
this.props,x=_props.x,y=_props.y,errorX=_props.errorX,errorY=_props.errorY;
var style=this.getStyle(nextProps);
if(
x!==nextProps.x||
y!==nextProps.y||
!(0,_isEqual3.default)(errorX,nextProps.errorX)||
!(0,_isEqual3.default)(errorY,nextProps.errorY))
{
this.style=style;
return true;
}
if((0,_isEqual3.default)(style,this.style)){
return false;
}else{
this.style=style;
return true;
}
}},{key:"getStyle",value:function getStyle(

props){var
style=props.style,datum=props.datum,active=props.active;
return _helpers2.default.evaluateStyle((0,_assign3.default)({stroke:"black"},style),datum,active);
}},{key:"renderLine",value:function renderLine(


props,style,events){
return _react2.default.createElement("line",_extends({},props,{style:style},events));
}},{key:"renderBorder",value:function renderBorder(

props,errors,type){var
x=props.x,y=props.y,borderWidth=props.borderWidth,events=props.events,style=props.style,role=props.role,shapeRendering=props.shapeRendering,className=props.className;
var vertical=type==="Right"||type==="Left";
var error=errors["error"+type];
var borderProps={
role:role,shapeRendering:shapeRendering,className:className,
key:"border"+type,
x1:vertical?error:x-borderWidth,
x2:vertical?error:x+borderWidth,
y1:vertical?y-borderWidth:error,
y2:vertical?y+borderWidth:error};

return this.renderLine(borderProps,style,events);
}},{key:"renderCross",value:function renderCross(

props,errors,type){var
x=props.x,y=props.y,events=props.events,style=props.style,role=props.role,shapeRendering=props.shapeRendering,className=props.className;
var vertical=type==="Top"||type==="Bottom";
var error=errors["error"+type];
var borderProps={
role:role,shapeRendering:shapeRendering,className:className,
key:"cross"+type,
x1:x,
x2:vertical?x:error,
y1:y,
y2:vertical?error:y};

return this.renderLine(borderProps,style,events);
}},{key:"renderErrorBar",value:function renderErrorBar(

error,props){var
groupComponent=props.groupComponent;
return _react2.default.cloneElement(groupComponent,{},
error.errorRight?this.renderBorder(props,error,"Right"):null,
error.errorLeft?this.renderBorder(props,error,"Left"):null,
error.errorBottom?this.renderBorder(props,error,"Bottom"):null,
error.errorTop?this.renderBorder(props,error,"Top"):null,
error.errorRight?this.renderCross(props,error,"Right"):null,
error.errorLeft?this.renderCross(props,error,"Left"):null,
error.errorBottom?this.renderCross(props,error,"Bottom"):null,
error.errorTop?this.renderCross(props,error,"Top"):null);

}},{key:"render",value:function render()

{var _props2=



this.props,x=_props2.x,y=_props2.y,borderWidth=_props2.borderWidth,groupComponent=_props2.groupComponent,events=_props2.events,errorX=_props2.errorX,errorY=_props2.errorY,scale=_props2.scale,role=_props2.role,shapeRendering=_props2.shapeRendering,className=_props2.className;
var rangeX=void 0;
var rangeY=void 0;
var positiveErrorX=void 0;
var negativeErrorX=void 0;
var positiveErrorY=void 0;
var negativeErrorY=void 0;
var errorTop=void 0;
var errorBottom=void 0;
var errorRight=void 0;
var errorLeft=void 0;

if(errorX){
rangeX=scale.x.range();
positiveErrorX=errorX[0];
negativeErrorX=errorX[1];
errorRight=positiveErrorX>=rangeX[1]?rangeX[1]:positiveErrorX;
errorLeft=negativeErrorX<=rangeX[0]?rangeX[0]:negativeErrorX;
}

if(errorY){
rangeY=scale.y.range();
positiveErrorY=errorY[1];
negativeErrorY=errorY[0];
errorTop=positiveErrorY>=rangeY[0]?rangeY[0]:positiveErrorY;
errorBottom=negativeErrorY<=rangeY[1]?rangeY[1]:negativeErrorY;
}
var props={
x:x,y:y,borderWidth:borderWidth,groupComponent:groupComponent,events:events,className:className,
role:role||"presentation",
shapeRendering:shapeRendering||"auto",
style:this.style};

return _react2.default.cloneElement(
this.props.groupComponent,
{},
this.renderErrorBar({errorTop:errorTop,errorBottom:errorBottom,errorRight:errorRight,errorLeft:errorLeft},props));

}}]);return ErrorBar;}(_react2.default.Component);ErrorBar.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,index:_react.PropTypes.number,datum:_react.PropTypes.object,data:_react.PropTypes.array,events:_react.PropTypes.object,scale:_react.PropTypes.object,shapeRendering:_react.PropTypes.string,role:_react.PropTypes.string,style:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number,errorX:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.array,_react.PropTypes.bool]),errorY:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.array,_react.PropTypes.bool]),borderWidth:_react.PropTypes.number,groupComponent:_react.PropTypes.element};ErrorBar.defaultProps={borderWidth:10};exports.default=ErrorBar;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/error-bar.js
// module id = 1416
// module chunks = 0